<template>
    <div class="orders-list">
        <template v-if="is_loading">
            <v-layout wrap align-center justify-center row fill-height>
                <v-progress-circular
                        indeterminate color="primary"
                        :size="70" :width="7">
                </v-progress-circular>
            </v-layout>
        </template>
        <template v-else>
            <template v-if="is_logged_in">
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 lg5>
                            <v-card fill-height>
                                <v-card-title class="primary title white--text black hidden-sm-and-down">
                                    <v-icon large left color="white">receipt</v-icon>
                                    <span>Архив заказов</span>
                                </v-card-title>
                                <v-card-title class="primary title white--text black hidden-md-and-up">
                                    <v-icon left color="white">receipt</v-icon>
                                    <span class="subheading">Архив заказов</span>
                                </v-card-title>
                                <v-card-text>

<div class="table-container hidden-sm-and-down">
    <v-data-table
            :headers="ol_headers" :items="orders_list" item-key="id"
            :pagination.sync="ol_pagination"
            :rows-per-page-items="ol_rows_per_page" rows-per-page-text="Строк на странице"
            :loading="ol_is_loading" :expand="ol_row_expanded" class="elevation-1"
    >
        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
        <template slot="headers" slot-scope="props">
            <tr>
                <template v-for="header in props.headers">
                    <template v-if="header.selected">
                        <th v-if="header.sortable" :key="header.text"
                            :class="['text-xs-' + header.align, 'column sortable', ol_pagination.descending ? 'desc' : 'asc', header.sort_value === ol_pagination.sortBy ? 'active' : '']"
                            @click="ol_change_sort(header.sort_value)">
                            <v-icon small>arrow_upward</v-icon>
                            {{ header.text }}
                        </th>
                        <th v-else :class="['column', 'text-xs-' + header.align]"
                            :key="header.text">
                            {{ header.text }}
                        </th>
                    </template>
                </template>
            <th class="column text-xs-center"><v-icon>list</v-icon></th>
            </tr>
        </template>

        <template slot="items" slot-scope="props">
            <tr v-if="props.item.status === 0" class="grey lighten-2">
                <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    <p style="margin-bottom: 0px;">{{ props.item.order_id }}</p>
                    <p class="primary--text" style="margin-bottom: 0px;">текущий</p>
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">{{ props.item.created | TO_DATE_TIME}}</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">???</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">???</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">???</td>
                <td class="text-xs-center">
                    <v-btn :disabled="true" icon flat class="primary--text">
                        <v-icon>open_in_new</v-icon>
                    </v-btn>
                </td>
            </tr>
            <tr v-else :class="[props.item.id === ol_selected ? 'primary lighten-5' : '']">
                <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    <p style="margin-bottom: 0px;">{{ props.item.order_id }}</p>
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">{{ props.item.created | TO_DATE_TIME}}</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">{{ props.item.modified | TO_DATE_TIME}}</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.orderitems.length}}</td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.total | TO_PRICE}}</td>
                <td class="text-xs-center">
                    <v-btn icon flat class="primary--text"
                           @click="load_order_items(props.item.id)" >
                        <v-icon>open_in_new</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <v-card flat class="info lighten-2">
                <v-card-text>
                    <v-layout row>
                        <v-flex xs2 align-self-center>
                            <span>Комментарий:</span>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs10 align-self-left>
                            <span class="pl-3">{{props.item.status > 0 ? props.item.commentary : '???'}}</span>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </template>
        <v-alert outline slot="no-data" :value="true" color="primary" icon="priority_high">
            У вас еще нет завершенных заказов.
        </v-alert>

    </v-data-table>
</div>

<div class="hidden-md-and-up">
    <v-data-iterator
            content-tag="v-layout" row wrap
            :items="orders_list" item-key="id"
            :pagination.sync="ol_pagination"
            :rows-per-page-items="ol_rows_per_page" rows-per-page-text="Строк на странице"
            :loading="ol_is_loading" class="elevation-1"
    >
        <template slot="item" slot-scope="props">
            <v-flex xs12 sm6>
                <v-card>
                    <v-card-title class="mob_item_title mob_item_title_text--text mob-s-item-title">
                        <v-layout row align-center justify-space-between>
                            <span class="subheading font-weight-bold">{{ props.item.order_id }}</span>
                            <v-btn icon flat class="mob_item_title_text--text"
                                   @click="load_order_items(props.item.id)" to="#oil_panel">
                                <v-icon>open_in_new</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                        <v-list-tile>
                            <v-list-tile-content>Создан:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.created | TO_DATE_TIME }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Изменен:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.modified | TO_DATE_TIME }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Позиций:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.orderitems.length }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Сумма:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.total | TO_PRICE }}</v-list-tile-content>
                        </v-list-tile>
                        <v-expansion-panel>
                            <v-expansion-panel-content class="grey lighten-3">
                                <template v-slot:header>
                                    <span class="body-1">Комментарий:</span>
                                </template>
                                <v-card flat class="grey lighten-3">
                                    <v-card-text>
                                        {{props.item.status > 0 ? props.item.commentary : '???'}}
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-list>
                </v-card>
            </v-flex>
        </template>
        <v-alert class="mx-2" outline slot="no-data" :value="true" color="primary" icon="priority_high">
            <span class="caption">У вас еще нет завершенных заказов.</span>
        </v-alert>

    </v-data-iterator>
</div>

                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 lg7>
                            <v-card fill-height>
                                <v-card-title class="accent title white--text black hidden-sm-and-down">
                                    <v-icon large left color="white">list</v-icon>
                                    <span>Товары заказа</span>
                                </v-card-title>
                                <v-card-title class="accent title white--text black hidden-md-and-up">
                                    <v-icon large left color="white">list</v-icon>
                                    <span class="subheading">Товары заказа</span>
                                </v-card-title>
                                <v-card-text>

<div class="table-container hidden-sm-and-down">

    <v-data-table
            :headers="oil_headers" :items="order_items_list" item-key="id"
            :pagination.sync="oil_pagination" :rows-per-page-items="oil_rows_per_page"
            rows-per-page-text="Строк на странице" :loading="oil_is_loading"
            :expand="oil_row_expanded" class="elevation-1"
    >
        <v-progress-linear slot="progress" color="accent" indeterminate></v-progress-linear>
        <template slot="headers" slot-scope="props">
            <tr>
                <template v-for="header in props.headers">
                    <template v-if="header.selected">
                        <th v-if="header.sortable" :key="header.text"
                            :class="['text-xs-' + header.align, 'column sortable',
                            oil_pagination.descending ? 'desc' : 'asc',
                            header.sort_value === oil_pagination.sortBy ? 'active' : '',
                            header.class]"
                            @click="oil_change_sort(header.sort_value)">
                            <v-icon small>arrow_upward</v-icon>
                            {{ header.text }}
                        </th>
                        <th v-else :class="['column', 'text-xs-' + header.align]"
                            :key="header.text">
                            {{ header.text }}
                        </th>
                    </template>
                </template>
                <th class="column text-xs-center">
                    <v-icon>add_shopping_cart</v-icon>
                </th>
            </tr>
        </template>

        <template slot="items" slot-scope="props">
            <tr>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    {{ props.item.item.name }}
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-left">
                    {{ props.item.item.article}}
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">
                    {{ props.item.quantity}}
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">
                    {{ props.item.price | TO_PRICE}}
                </td>
                <td @click="props.expanded = !props.expanded" class="text-xs-right">
                    {{ props.item.total | TO_PRICE}}
                </td>
                <td @click="props.expanded = !props.expanded"
                    :class="['text-xs-right',
                    props.item.price >= props.item.price_now.value ? 'accent--text' : 'primary--text']">
                    <p style="margin-bottom: 0px">{{ props.item.price_now.value | TO_PRICE}}</p>
                    <p v-if="props.item.price - props.item.price_now.value !== 0" style="margin-bottom: 0px">
                        Разн.: {{format_diff_price(props.item.price, props.item.price_now.value)}}
                    </p>
                </td>
                <td>
                    <v-edit-dialog
                            large lazy
                            @open="open_item_to_cart()"
                            @save="save_item_to_cart(props.item, order_item_send_qty, true, false, {})"
                            cancel-text="Отмена"
                            save-text="В заказ"
                    >
                        <v-btn flat icon fab small v-bind:class="[current_order_items_list.indexOf(props.item.item.id) > -1 ? 'primary--text' : 'info--text']">
                            <v-icon medium>add_circle_outline</v-icon>
                        </v-btn>
                        <div slot="input" class="mt-3 title">Введите количество</div>
                        <v-text-field
                                slot="input" v-model.number="order_item_send_qty"
                                min="1" step="10"
                                label="QTY" single-line autofokus
                                append-outer-icon="add_circle_outline"
                                @click:append-outer="order_item_send_qty+=1"
                                prepend-icon="remove_circle_outline"
                                @click:prepend="[order_item_send_qty > 1 ? order_item_send_qty-=1 : order_item_send_qty=1]"
                                suffix="шт." type="number"
                                v-on:keyup.enter="save_item_to_cart(props.item, order_item_send_qty, true, false, {})"
                        ></v-text-field>
                        <div slot="input" class="mt-3 subheading">
                            Стоимость: <b>{{order_item_send_qty *
                            props.item.price_now.value | TO_PRICE}}</b>
                        </div>
                    </v-edit-dialog>
                </td>
            </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <v-card flat class="info lighten-2">
                <v-card-text>
                    <v-layout row>
                        <v-flex xs2 align-self-center>
                            Каталог: <b>{{props.item.item.id_parent.name}}</b>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs7 align-self-center>
                            {{props.item.item.description}}
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs3 align-self-center style="font-family: monospace;">
                            Штук в кор.: {{props.item.item.package_qty}}
                            <br/>
                            ШК шт. : {{props.item.item.sku_pcs}}
                            <br/>
                            ШК кор.: {{props.item.item.sku_pkg}}
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </template>
        <v-alert outline slot="no-data" :value="true" color="accent"
                 :icon="oil_alert_icon">
            <span>{{oil_alert_text}}</span>
        </v-alert>
    </v-data-table>
</div>

<div class="hidden-md-and-up" id="oil_panel">
    <v-data-iterator content-tag="v-layout" row wrap
            :items="order_items_list" item-key="id"
            :pagination.sync="oil_pagination" :rows-per-page-items="oil_rows_per_page"
            rows-per-page-text="Строк на странице" :loading="oil_is_loading"
            class="elevation-1"
    >
        <template slot="item" slot-scope="props">
            <v-flex xs12 sm6 md4 lg3>
                <v-card>
                    <v-card-title class="mob_item_title mob_item_title_text--text mob-s-item-title">
                        <v-layout row wrap align-center justify-space-between>
                            <v-flex xs9>
                                <span class="body-1 font-weight-bold">{{ props.item.item.article }}</span>
                            </v-flex>
                            <v-flex xs3>
                                <v-edit-dialog
                                        large lazy
                                        @open="open_item_to_cart()"
                                        @save="save_item_to_cart(props.item, order_item_send_qty, true, false, {})"
                                        cancel-text="Отмена"
                                        save-text="В заказ"
                                >
                                    <v-btn flat icon fab small
                                           style="float: right;"
                                           v-bind:class="[current_order_items_list.indexOf(props.item.item.id) > -1 ?
                                           'mob_item_btn_in_cart--text' : 'mob_item_title_text--text']">
                                        <v-icon medium>add_circle_outline</v-icon>
                                    </v-btn>
                                    <div slot="input" class="mt-3 title">Введите количество</div>
                                    <v-text-field
                                            slot="input" v-model.number="order_item_send_qty"
                                            min="1" step="10"
                                            label="QTY" single-line autofokus
                                            append-outer-icon="add_circle_outline"
                                            @click:append-outer="order_item_send_qty+=1"
                                            prepend-icon="remove_circle_outline"
                                            @click:prepend="[order_item_send_qty > 1 ? order_item_send_qty-=1 : order_item_send_qty=1]"
                                            suffix="шт." type="number"
                                            v-on:keyup.enter="save_item_to_cart(props.item, order_item_send_qty, true, false, {})"
                                    ></v-text-field>
                                    <div slot="input" class="mt-3 subheading">
                                        Стоимость: <b>{{order_item_send_qty *
                                        props.item.price_now.value | TO_PRICE}}</b>
                                    </div>
                                </v-edit-dialog>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-divider></v-divider>
                    <p class="primary--text ml-3 mt-2" style="margin-bottom: 0px">{{props.item.item.name}}</p>
                    <v-divider></v-divider>
                    <v-list dense>
                        <v-list-tile>
                            <v-list-tile-content>Количество:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.quantity }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Цена:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.price | TO_PRICE }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Сумма:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.total | TO_PRICE }}</v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-list-tile>
                            <v-list-tile-content>Цена сейчас:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                                <div :class="['text-xs-right',
                                props.item.price >= props.item.price_now.value ?
                                'accent--text' : 'primary--text']">
                                    <p style="margin-bottom: 0px">{{ props.item.price_now.value | TO_PRICE}}</p>
                                    <p v-if="props.item.price - props.item.price_now.value !== 0"
                                       style="margin-bottom: 0px">
                                        Разн.: {{format_diff_price(props.item.price, props.item.price_now.value)}}
                                    </p>
                                </div>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-expansion-panel>
                            <v-expansion-panel-content class="grey lighten-2">
                                <template v-slot:header>
                                    <span class="body-1">Дополнительно</span>
                                </template>
                                <v-card flat class="grey lighten-4">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 align-self-center>
                                                <span class="font-weight-bold">Каталог:</span> {{props.item.item.id_parent.name}}
                                            </v-flex>
                                            <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                            <v-flex xs12 align-self-center style="font-family: monospace;">
                                                Штук в кор.: {{props.item.item.package_qty}}
                                                <br/>
                                                ШК шт. : {{props.item.item.sku_pcs}}
                                                <br/>
                                                ШК кор.: {{props.item.item.sku_pkg}}
                                            </v-flex>
                                            <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                            <v-flex xs12 align-self-center>
                                                <span class="font-weight-bold">Описание:</span> {{props.item.item.description}}
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-list>
                </v-card>
            </v-flex>
        </template>
        <v-alert class="mx-2" outline slot="no-data" :value="true" color="accent"
                 :icon="oil_alert_icon">
            <span class="caption">{{oil_alert_text}}</span>
        </v-alert>
    </v-data-iterator>
</div>

                                </v-card-text>
                                <v-card-actions>
                                    <v-container class="mx-2 pa-1" fluid>
                                        <v-layout wrap pa-1 align-center justify-space-between row fill-height>
                                            <v-flex xs12 md4>
                                                <p class="subheading"
                                                   style="margin-bottom: 0px; margin-right: 5px;">Добавить все: </p>
                                            </v-flex>
                                            <v-flex xs12 md4>
                                                <v-btn block color="accent" fill-height
                                                       :disabled="order_items_list.length === 0"
                                                       @click="oil_add_all_to_cart(false)"
                                                       :loading="oil_add_all_loading1">
                                                    <span class="font-weight-medium">по 1 шт</span>
                                                    <v-icon right>add_shopping_cart</v-icon>
                                                </v-btn>
                                            </v-flex>
                                            <v-flex xs12 md4>
                                                <v-btn block color="accent" fill-height
                                                       :disabled="order_items_list.length === 0"
                                                       @click="oil_add_all_to_cart(true)"
                                                       :loading="oil_add_all_loading2">
                                                    <span class="font-weight-medium">в кол-вах заказа</span>
                                                    <v-icon right>add_shopping_cart</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-container>
                <v-snackbar v-model="snack" :timeout="6000" :color="snackColor">
                    {{ snackText }}
                    <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
                </v-snackbar>
            </template>
            <template v-else>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card>
                            <v-card-text>
                                <v-alert :value="true" outline type="error">
                                    <p>Страница недоступна анонимным пользователям.</p>
                                    <p>Пожалуйста, авторизуйтесь.</p>
                                </v-alert>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </template>
        </template>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { Globals } from '@/globals.js';
    import moment from 'moment';

    export default {
        name: "OrdersList",
        data(){
            return {
                // Orders list
                orders_list: [],
                ol_selected: '',
                ol_headers: [
                    { selected: true, sortable: true, text: 'Номер', align: 'left', value: 'order_id', sort_value: 'order_id'},
                    { selected: true, sortable: true, text: 'Создан', align: 'left', value: 'created', sort_value: 'created'},
                    { selected: true, sortable: true, text: 'Изменен', align: 'left', value: 'modified', sort_value: 'modified'},
                    { selected: true, sortable: true, text: 'Позиций', align: 'right', value: 'orderitems.length', sort_value: 'orderitems.length'},
                    { selected: true, sortable: true, text: 'Сумма', align: 'right', value: 'total', sort_value: 'total'},
                    { selected: false, sortable: false, text: 'Icon', align: 'left', value: 'icon', sort_value: 'icon' },
                ],
                ol_is_loading: false,
                ol_rows_per_page: [5, 10, 25, 50, 100],
                ol_row_expanded: true,
                ol_pagination: {
                    descending: false,
                    sortBy: 'name',
                    rowsPerPage: 5,
                    selected_page: 1
                },
                // Order items list
                order_items_list: [],
                oil_headers: [
                    { selected: true, sortable: true, text: 'Товар', align: 'left', value: 'item.name',
                        sort_value: 'item.name', class: ''},
                    { selected: true, sortable: true, text: 'Артикул', align: 'left', value: 'item.article',
                        sort_value: 'item.article', class: ''},
                    { selected: true, sortable: true, text: 'Кол-во', align: 'right', value: 'quantity',
                        sort_value: 'quantity', class: ''},
                    { selected: true, sortable: true, text: 'Цена', align: 'right', value: 'price',
                        sort_value: 'price', class: ''},
                    { selected: true, sortable: true, text: 'Сумма', align: 'right', value: 'total',
                        sort_value: 'total', class: ''},
                    { selected: true, sortable: true, text: 'Цена сейчас', align: 'right', value: 'price_now.value',
                        sort_value: 'price_now.value', class: 'accent--text font-weight-medium'},
                    { selected: false, sortable: false, text: 'Icon', align: 'left', value: 'icon', sort_value: 'icon' },
                ],
                oil_is_loading: false,
                oil_rows_per_page: [10, 25, 50, 100],
                oil_row_expanded: true,
                oil_pagination: {
                    descending: false,
                    sortBy: 'item.article',
                    rowsPerPage: 10,
                    selected_page: 1
                },
                oil_alert_icon: '',
                oil_alert_text: '',
                // OIL Add All
                oil_add_all_loading1: false,
                oil_add_all_loading2: false,
                // Order items
                order_items: [],
                order_id: '',
                order_item_send_id: '',
                order_item_send_qty: 0,
                order_item_send_price: 0.00,
                // Fetching
                is_loading: true,
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
            }
        },
        created() {
            if (sessionStorage.getItem('auth_token')) {
                $.ajaxSetup({
                    headers: {'Authorization': 'Token ' + sessionStorage.getItem('auth_token')},
                });
                this.get_user_orders();
            } else {
                this.is_loading = false;
            }
            this.ol_set_default_sort();
            this.oil_setup_alert(false);
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            current_order_items_list() { return this.$store.getters.order_goods_list_get},
            current_order() { return this.$store.getters.order_info_get },
        },
        methods: {
            get_user_orders() {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'order/orders/',
                    type: 'GET',
                    data: {
                        status__gt: 0,
                    },
                    success: (response) => {
                        this.orders_list = response;
                    },
                    error: () => {
                        this.orders_list = [];
                    },
                    complete:() => {
                        this.is_loading = false;
                    }
                })
            },
            get_order_items(item_id){
                this.oil_is_loading = true;
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'order/items/',
                    type: 'GET',
                    data: {
                        order_id: item_id,
                    },
                    success: (response) => {
                        this.order_items_list = response;
                    },
                    error: (response) => {
                        this.order_items_list = [];
                        if(response.responseJSON.detail)
                            this.show_snack('error', response.responseJSON.detail);
                        else
                            this.show_snack('error', response.responseText);
                    },
                    complete: () => {
                        this.oil_is_loading = false;
                        this.oil_setup_alert(true);
                    }
                })
            },
            // Add to cart
            open_item_to_cart(){
                this.order_item_send_qty = 1;
            },
            save_item_to_cart(item, qty, stop_loading, stage2, many){
                if (qty < 1) {
                    this.show_snack('error', 'Некорректное количество');
                    return;
                }
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orderitems/',
                    type: 'POST',
                    data: {
                        item: item.item.id,
                        quantity: qty,
                        price: item.price_now.value,
                    },
                    success: () => {
                        this.show_snack('success', 'Добавлено в заказ');
                        this.$store.dispatch('order_info_init');
                    },
                    error: (response) => {
                        if(response.responseJSON)
                            if (response.responseJSON.detail)
                                this.show_snack('error', 'Ошибка: ' + response.responseJSON.detail);
                            else
                                this.show_snack('error', 'Ошибка: ' + response.responseText);
                        else
                            this.show_snack('error', 'Ошибка: ' + response.responseText);
                    },
                    complete: () => {
                        if(stop_loading === true) {
                            this.oil_add_all_loading2 = false;
                            this.oil_add_all_loading1 = false;
                        }
                        if(stage2 === true){
                            this.oil_add_all_to_cart_stage2(many.use_order_qty, many.start_index);
                        }
                    }
                })
            },
            oil_add_all_to_cart(use_order_qty) {
                if(use_order_qty === true)
                    this.oil_add_all_loading2 = true;
                else
                    this.oil_add_all_loading1 = true;
                var qty = 1;
                var many = {start_index: 0, use_order_qty: use_order_qty};
                // No active order
                if(this.order_items_list.length > 1) {
                    if (!this.current_order.id) {
                        if (use_order_qty)
                            qty = this.order_items_list[0].quantity;
                        many.start_index = 1;
                        this.save_item_to_cart(this.order_items_list[0], qty, false, true, many);
                        return;
                    }
                }
                this.oil_add_all_to_cart_stage2(use_order_qty, many.start_index);
            },
            oil_add_all_to_cart_stage2(use_order_qty, start_index) {
                var qty = 1;
                for (var index = start_index; index < this.order_items_list.length; index++){
                    if (use_order_qty)
                        qty = this.order_items_list[index].quantity;
                    this.save_item_to_cart(this.order_items_list[index], qty, index === this.order_items_list.length-1, false, {});
                }
            },
            // Table
            ol_change_sort(column) {
                if (this.ol_pagination.sortBy === column) {
                    this.ol_pagination.descending = !this.ol_pagination.descending
                } else {
                    this.ol_pagination.sortBy = column;
                    this.ol_pagination.descending = false
                }
            },
            oil_change_sort(column) {
                if (this.oil_pagination.sortBy === column) {
                    this.oil_pagination.descending = !this.oil_pagination.descending
                } else {
                    this.oil_pagination.sortBy = column;
                    this.oil_pagination.descending = false
                }
            },
            ol_set_default_sort(){
                this.ol_pagination.descending = true;
                this.ol_pagination.sortBy = 'modified';
            },
            load_order_items(item_id){
                this.ol_selected = item_id;
                this.get_order_items(item_id);
                $('html, body').animate({
                    scrollTop: $('#oil_panel').offset().top - 130
                }, 500);
            },
            oil_setup_alert(after_loading){
                if(after_loading){
                    if(this.order_items_list.length === 0){
                        this.oil_alert_icon = 'error_outline';
                        this.oil_alert_text = 'Заказ не содержит товаров';
                    }
                } else {
                    this.oil_alert_icon = 'open_in_new';
                    this.oil_alert_text = 'Выберите заказ для отображения';
                }
            },
            format_diff_price(price1, price2){
                return parseFloat(Math.round((price1 - price2) * 100) / 100).toFixed(2);
            },
            // Form MISC
            show_snack(snack_color, snack_text){
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
        },
        filters: {
            TO_PRICE(value) {
                if(value)
                    return `₽ ${value.toLocaleString()}`;
                else
                    return "--";
            },
            TO_DATE_TIME(value) {
                if(value)
                    return moment(String(value)).format('YYYY-MM-DD HH:mm');
                else
                    return "no data";
            }
        },
    }
</script>

<style scoped>

</style>